import {
    FETCH_PROPERTYGROUPS,
    FETCH_PROPERTYGROUPS_ACCUMULATED,
    FETCH_PROPERTYGROUPS_FAILURE,
    FETCH_PROPERTYGROUPS_SUCCESS,

    FETCH_PROPERTYGROUPS_LOCALISATION,
    FETCH_PROPERTYGROUPS_LOCALISATION_FAILURE,
    FETCH_PROPERTYGROUPS_LOCALISATION_SUCCESS,

    FETCH_PROPERTYGROUP,
    FETCH_PROPERTYGROUP_ACCUMULATED,
    FETCH_PROPERTYGROUP_FAILURE,
    FETCH_PROPERTYGROUP_SUCCESS,

    FETCH_PROPERTYGROUP_LOCALISATION,
    FETCH_PROPERTYGROUP_LOCALISATION_FAILURE,
    FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const fetchPropertygroups = (payload) => {
    payload = payload || {};

    const params = {
        size: payload.size || 24,
        sort_by: payload.field || 'name',
        sort_direction: 'desc',
    };

    if (!payload.offset && payload.page) {
        params.offset = (payload.page - 1) * params.size;
    }

    return {
        type: FETCH_PROPERTYGROUPS,
        payload: params,
    };
};

export const fetchPropertygroupsFailure = (error) => {
    return {
        type: FETCH_PROPERTYGROUPS_FAILURE,
        error: error,
    };
};

export const fetchPropertygroupsSuccess = (payload) => {
    return {
        type: FETCH_PROPERTYGROUPS_SUCCESS,
        payload: payload,
    };
};

export const fetchPropertygroupsLocalisation = (payload) => {
    return {
        type: FETCH_PROPERTYGROUPS_LOCALISATION,
        payload: payload,
    };
};

export const fetchPropertygroupsLocalisationFailure = (error) => {
    return {
        type: FETCH_PROPERTYGROUPS_LOCALISATION_FAILURE,
        error: error,
    };
};

export const fetchPropertygroupsLocalisationSuccess = (payload) => {
    return {
        type: FETCH_PROPERTYGROUPS_LOCALISATION_SUCCESS,
        payload: payload,
    };
};

export const fetchPropertygroup = (payload) => {
    return {
        type: FETCH_PROPERTYGROUP,
        payload: payload,
    };
};

export const fetchPropertygroupFailure = (error) => {
    return {
        type: FETCH_PROPERTYGROUP_FAILURE,
        error: error,
    };
};

export const fetchPropertygroupSuccess = (response) => {
    return {
        type: FETCH_PROPERTYGROUP_SUCCESS,
        response: response,
    };
};

export const fetchPropertygroupLocalisation = (payload) => {
    return {
        type: FETCH_PROPERTYGROUP_LOCALISATION,
        payload: payload,
        id: payload.id,
    };
};

export const fetchPropertygroupLocalisationFailure = (error) => {
    return {
        type: FETCH_PROPERTYGROUP_LOCALISATION_FAILURE,
        error: error,
    };
};

export const fetchPropertygroupLocalisationSuccess = (payload, response) => {
    return {
        type: FETCH_PROPERTYGROUP_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};

export const updateListParams = (payload) => {
    return {
        type: payload.type,
        payload: payload.payload,
    };
};

export const fetchPropertyGroupAccumulated = (payload) => {
    return {
        type: FETCH_PROPERTYGROUP_ACCUMULATED,
        payload: {
            id: payload.id,
            resource: 'propertygroups',
            type: FETCH_PROPERTYGROUPS_ACCUMULATED,
        },
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/propertygroups/fetchPropertygroups.js